import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PERSONNEL_FEATURE_KEY, personnelAdapter, PersonnelState } from './personnel.reducer';

// Lookup the 'Personnel' feature state managed by NgRx
export const getPersonnelState = createFeatureSelector<PersonnelState>(PERSONNEL_FEATURE_KEY);

const { selectAll, selectEntities } = personnelAdapter.getSelectors();

export const getPersonnelLoaded = createSelector(getPersonnelState, (state: PersonnelState) => state.loaded);

export const getPersonnelError = createSelector(getPersonnelState, (state: PersonnelState) => state.error);

export const getAllPersonnel = createSelector(getPersonnelState, (state: PersonnelState) => selectAll(state));

export const getPersonnelEntities = createSelector(getPersonnelState, (state: PersonnelState) => selectEntities(state));

export const getSelectedId = createSelector(getPersonnelState, (state: PersonnelState) => state.selectedId);

export const getSelected = createSelector(getPersonnelEntities, getSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
);

export const getPersonnelById = (id: string) => createSelector(getPersonnelEntities, entities => (id ? entities[id] : undefined));
